<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .inputs {
    display: flex;
    width: 100%;
    flex-wrap: no-wrap;
    gap: utils.in_rem(8px);
    justify-content: space-between;

    .input {
      width: calc(100% / 3 - 4px);
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }
  }
</style>

<script>
  import Checkbox from "@sourcewhale/shared/svelte-design-system/components/atoms/Checkbox/Checkbox.svelte";
  import Label from "@sourcewhale/shared/svelte-design-system/components/atoms/InputLabels/Label.svelte";
  import NumberInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/NumberInput.svelte";
  import {
    additionsStore,
    modulePricingApiStore,
    priceSuffixStore,
  } from "../stores";

  let { mod } = $props();

  let price = $derived($modulePricingApiStore?.modules[mod.kind] || 0);
  let totalPrice = $derived($additionsStore[mod.kind] * price);

  const getChecked = () => $additionsStore[mod.kind] > 0;
  const setChecked = (v) => {
    $additionsStore[mod.kind] = v ? 1 : 0;
  };
</script>

<div class="inputs">
  <div class="input">
    <Label label="Purchase for team" labelSize="small" />
    <Checkbox bind:checked={getChecked, setChecked} />
  </div>
  <div class="input">
    <Label label="Total Price{$priceSuffixStore}" labelSize="small" />
    <NumberInput style="width:100%" value={totalPrice} disabled={true} />
  </div>
</div>
